import { BookingModalMode } from "./use_booking_modal";

export const getHeaderTitleTranslationKey = (mode: BookingModalMode | undefined) => {
  if (mode === BookingModalMode.Edit) {
    return "bookings.update.editBooking";
  }
  if (mode === BookingModalMode.Clone) {
    return "bookings.clone.cloneBooking";
  }
  return "bookings.create.createBooking";
};

export const getSubmitSuccessMessageTranslationKey = (mode: BookingModalMode | undefined) => {
  if (mode === BookingModalMode.Edit) {
    return "bookings.update.success";
  }
  if (mode === BookingModalMode.Clone) {
    return "bookings.clone.success";
  }
  return "bookings.create.success";
};

export const getSubmitErrorMessageTranslationKey = (mode: BookingModalMode | undefined) => {
  if (mode === BookingModalMode.Edit) {
    return "bookings.update.error";
  }
  if (mode === BookingModalMode.Clone) {
    return "bookings.clone.error";
  }
  return "bookings.create.error";
};

export const getAcceptButtonTranslationKey = (mode: BookingModalMode | undefined) => {
  if (mode === BookingModalMode.Clone) {
    return "bookings.clone.cloneAction";
  }
  return "accept";
};
